import { render, staticRenderFns } from "./allocation-plan-add.vue?vue&type=template&id=991c6396&scoped=true"
import script from "./allocation-plan-add.vue?vue&type=script&lang=js"
export * from "./allocation-plan-add.vue?vue&type=script&lang=js"
import style0 from "./allocation-plan-add.vue?vue&type=style&index=0&id=991c6396&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991c6396",
  null
  
)

export default component.exports